import { render, staticRenderFns } from "./ChannelDisplay.vue?vue&type=template&id=7c468772&scoped=true&"
import script from "./ChannelDisplay.vue?vue&type=script&lang=ts&"
export * from "./ChannelDisplay.vue?vue&type=script&lang=ts&"
import style0 from "./ChannelDisplay.vue?vue&type=style&index=0&id=7c468772&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c468772",
  null
  
)

export default component.exports